export default __webpack_public_path__ + "static/media/LHS_Badge_mitZusatz_sw_Print.76460ee7.jpg";